import { twMerge } from "tailwind-merge";
import { Typography } from "@pondigitalsolutions/pon-component-library";

import { Pill } from "./Pill";

const STATUS_VARIANTS = {
  success: "border-accent_two-500",
  error: "border-accent_three-700",
  warning: "border-accent_one-600",
  info: "border-primary-500",
};

interface AlertProps {
  labelText: string;
  text: string | React.ReactNode;
  variant?: keyof typeof STATUS_VARIANTS;
  className?: string;
  textClassName?: string;
  "data-testid"?: string;
  rightSlot?: React.ReactNode;
}

export const Alert = ({
  labelText,
  text,
  variant = "info",
  className,
  textClassName,
  "data-testid": testId,
  rightSlot,
}: AlertProps) => {
  return (
    <div
      className={twMerge(
        "flex max-w-125 items-center gap-2 rounded-full border bg-white/10 px-2 py-1.5 lg:px-4 lg:py-3",
        STATUS_VARIANTS[variant],
        className
      )}
      data-testid={testId}
    >
      <Pill variant={variant}>{labelText}</Pill>
      <div className="min-w-0 flex-1">
        <Typography
          size="sm"
          className={twMerge("leading-none font-normal", textClassName)}
        >
          {text}
        </Typography>
      </div>
      {rightSlot && (
        <div className="ml-auto flex items-center gap-2">{rightSlot}</div>
      )}
    </div>
  );
};
